import React from "react"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"

export type MenuHeaderProps = {
  /** Header content, typically a label for a group of items */
  children?: React.ReactNode
}

const headerStyles = "p-2 text-xs font-semibold text-gray-700"

export function MenuHeader({ children }: MenuHeaderProps) {
  return (
    <MenuPrimitive.GroupLabel data-slot="menu-header" className={headerStyles}>
      {children}
    </MenuPrimitive.GroupLabel>
  )
}

MenuHeader.displayName = "Menu.Header"
